export default "__VITE_ASSET__8a0e4626__"